import React, { Component } from "react";
import { Container, Button } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faSave} from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage, injectIntl } from "react-intl";
import debounce from 'lodash/debounce'
import pick from 'lodash/pick'

import RangeSlider from "../../components/form/RangeSlider";
import JobsPageJobsGrid
    from "../../components/portfolio/JobsPage/JobsPageJobsGrid";
import BusinessUnitButton
    from "../../components/portfolio/JobsPage/BusinessUnitButton";
import HomepageGuide from "../../components/portfolio/Homepage/HomepageGuide";
import Faq from "../../components/Faq/Faq";
import {
    faqCardsBody,
    faqCardsHeader
} from "../../components/Faq/Pages/JobsPage";

import "react-input-range/lib/css/index.css";
import { storage } from '../../helpers/storage'

import { withRouter } from 'react-router-dom';
import MetaTags from '../../components/SEO/MetaTags'
import { handlePublicRequestError, Request } from '../../helpers/request'
import { businessUnitOptions } from '../../helpers/select'
import LocalisationSelect from '../../components/form/LocalisationSelect'
import RemoteSelect from '../../components/form/RemoteSelect'
import Helmet from 'react-helmet'
import BusinessCategorySelect
    from "../../components/form/BusinessCategorySelect";
import { FILTERS_KEY_JOBS_PAGE } from '../../providers/TemporaryFiltersProvider'
import SaveJobAlertModal from "../../components/portfolio/modals/SaveJobAlertModal";

const filtersInitialState = {
    page: 1,
    salary: {
        min: 20,
        max: 150
    },
    location: '',
    remote: null,
    business_unit: null,
    business_unit_category: null,
    skills: ''
}

class JobsPage extends Component {
    state = {
        ...filtersInitialState,
        pagination: 17,
        business_unit_category_options: [],
        data: [],
        loading: false,
        saveJobAlertModal: false
    };

    button_ref = React.createRef();

    componentDidMount() {
        const filters = storage.getItem(FILTERS_KEY_JOBS_PAGE)
        if (filters) {
            this.setState(JSON.parse(filters), () => this.fetch(false))
        } else {
            this.fetch(false);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params?.business_unit !== this.props.match.params?.business_unit) {
            this.fetch(false)
        }
    }

    fetch = debounce((concat = true, offset = null) => {
        this.setState({
            loading: true,
            business_unit: this.props.match.params?.business_unit ?? null
        });

        let fullUri = 'job_orders/paginated?page=' + this.state.page +
            (this.state.pagination ? '&pagination=' + this.state.pagination : '') +
            (this.state.location ? '&location=' + this.state.location : '') +
            (this.state.remote !== null ? '&remote=' + this.state.remote : '') +
            (this.state.business_unit ? '&business_unit=' + this.state.business_unit : '') +
            (this.state.business_unit_category ? '&business_unit_category=' + this.state.business_unit_category : '') +
            (this.state.salary && this.state.salary.min ? '&salary_low=' + this.state.salary.min : '') +
            (this.state.salary && this.state.salary.max ? '&salary_high=' + this.state.salary.max : '') +
            (this.state.skills ? '&skills=' + this.state.skills : '') +
            (this.props.match?.params?.consultant ? '&owner_id=' + this.props.match.params.consultant : '');

        Request.get(fullUri)
            .then((offers) => {
                const { intl } = this.props;
                const { data } = this.state;

                if (offers.business_unit_category_options) {
                    offers.business_unit_category_options.unshift({
                        id: null,
                        label: intl.formatMessage({
                            id: "portfolio.digital.pole.all.categories.label",
                            defaultMessage: "Toutes"
                        })
                    });
                }

                this.setState({
                    data: concat ? data.concat(offers.data) : offers.data,
                    business_unit_category_options: offers.business_unit_category_options,
                    loading: false
                }, () => offset ? window.scrollTo(0, offset) : null);
            })
            .catch((e) => {
                handlePublicRequestError(e);
                this.setState({ loading: false });
            });
    }, 400);

    handleMore() {
        this.setState({ page: this.state.page + 1 }, () => this.fetch(true, window.pageYOffset));
    }

    resetFilters() {
        storage.removeItem(FILTERS_KEY_JOBS_PAGE)
        this.setState({ ...filtersInitialState }, () => this.fetch(false));
    }

    setStateAndFetch(newState) {
        const statePick = pick(this.state, Object.keys(filtersInitialState))
        const filters = { ...statePick, ...newState, page: 1 }
        storage.setItem(FILTERS_KEY_JOBS_PAGE, JSON.stringify(filters))
        this.setState({ ...newState, page: 1 }, () => this.fetch(false));
    }

    render() {
        const { intl } = this.props;
        const translationKey = this.props.match?.params?.business_unit ?? 'home'

        return (
            <div className="jobs-page">
                <div id="business-categories-options-menu"
                     className="react-select-container" />
                {this.props.match?.params?.consultant &&
                    <Helmet>
                        <meta name="robots" content="noindex" />
                    </Helmet>}

                <MetaTags page="job" data={{
                    business_unit: translationKey
                }} />

                <section className="job-search">
                    <Container className={"jobs-page-head"}>
                        <h1 className="line-heading">
                            {intl.formatMessage({
                                id: "portfolio.jobs.pole." + translationKey + ".title",
                                defaultMessage: "Les meilleures offres d'emploi du digital"
                            })}
                        </h1>

                        <p>
                            {intl.formatMessage({
                                id: "portfolio.jobs.pole." + translationKey + ".hat",
                                defaultMessage: "Retrouvez ici toutes les offres d'emploi de l'écosystème du digital (tech, marketing, product...) proposées par les partenaires d'Urban Linker. Des opportunités à ne pas manquer pour vous ou pour un proche que vous pouvez recommander avec la cooptation."
                            })}
                        </p>


                        <div className="field-wrap">
                            <div className="form-group">
                                <label>
                                    <FormattedMessage
                                        id="portfolio.jobs.keywords.label"
                                        defaultMessage="Métiers, compétences, technos"
                                    />
                                </label>
                                <input
                                    value={this.state.skills}
                                    onChange={(e) => this.setStateAndFetch({
                                        skills: e.target.value,
                                    })}
                                    className="input-field"
                                    placeholder={
                                        intl.formatMessage({
                                            id: "portfolio.jobs.keywords.placeholder",
                                            defaultMessage: "Technos, métiers, compétences"
                                        })
                                    }
                                />
                            </div>
                            <div className="wage form-group">
                                <label>
                                    <FormattedMessage
                                        id="portfolio.jobs.salary.label"
                                        defaultMessage="Salaire souhaité"
                                    />
                                </label>
                                <RangeSlider
                                    value={this.state.salary}
                                    maxValue={150}
                                    minValue={20}
                                    onChange={range => this.setStateAndFetch({ salary: range })}
                                    formatLabel={value => `${value}K`}
                                />
                            </div>
                            <div className="form-group">
                                <label>
                                    <FormattedMessage
                                        id="portfolio.jobs.location.label"
                                        defaultMessage="Localisation"
                                    />
                                </label>
                                <LocalisationSelect
                                    value={this.state.location}
                                    onChange={location => this.setStateAndFetch({ location })}
                                    placeholder={
                                        intl.formatMessage({
                                            id: "portfolio.jobs.location.placeholder",
                                            defaultMessage: "Paris"
                                        })
                                    }
                                />
                            </div>
                            <div className="form-group">
                                <label>
                                    <FormattedMessage
                                        id="portfolio.jobs.remove.label"
                                        defaultMessage="Télétravail"
                                    />
                                </label>
                                <RemoteSelect
                                    value={this.state.remote}
                                    onChange={remote => this.setStateAndFetch({ remote })}
                                />
                            </div>
                        </div>
                        <div className="check-list">
                            <label>
                                <FormattedMessage
                                    id="portfolio.jobs.business_unit.label"
                                    defaultMessage="Sélectionnez un ou plusieurs pôles"
                                />
                            </label>
                            <ul>
                                <li>
                                    <BusinessUnitButton
                                        option={{
                                            value: '',
                                            label: intl.formatMessage({
                                                id: "portfolio.digital.pole.all.label",
                                                defaultMessage: "Tous"
                                            })
                                        }}
                                        state={this.state}
                                    />
                                </li>
                                {businessUnitOptions.map((option, key) => {
                                    return (
                                        <li key={key}>
                                            <BusinessUnitButton
                                                option={option}
                                                state={this.state}
                                            />
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                        {(this.state.business_unit) &&
                            <div
                                className="field-wrap business-category-select">
                                <div className="form-group" style={{ flex: 1 }}>
                                    <label>
                                        <FormattedMessage
                                            id="portfolio.jobs.business_category.label"
                                            defaultMessage="Sélectionnez une catégorie"
                                        />
                                    </label>
                                    <BusinessCategorySelect
                                        value={this.state.business_unit_category}
                                        options={this.state.business_unit_category_options}
                                        onChange={business_unit_category => this.setStateAndFetch({ business_unit_category })}
                                    />
                                </div>
                            </div>
                        }

                        <div className={"jobs-page-head-cta-wrapper"}>
                            <span className={"save-filter-modal"} onClick={() => {
                                this.setState({saveJobAlertModal: true})
                            }}>
                                <i><FontAwesomeIcon icon={faSave} />&nbsp;</i>
                                <FormattedMessage
                                    id="portfolio.jobs.save_filter_modal.button"
                                    defaultMessage="créer une alerte sur ces critères"
                                />
                            </span>
                            <span className="delete-text"
                                  onClick={() => this.resetFilters()}>
                                <i><FontAwesomeIcon
                                    icon={faTrashAlt} />&nbsp;</i>
                                <FormattedMessage
                                    id="app.remove_filters"
                                    defaultMessage="Effacer les critères"
                                />
                            </span>
                        </div>
                    </Container>
                </section>

                <JobsPageJobsGrid offers={this.state.data}
                                  handleMore={() => this.handleMore()}
                                  loading={this.state.loading}
                                  forwardedRef={this.button_ref} />

                <div className="jobs-faq">
                    <div className="container">
                        <div className="jobs-faq-header">
                            <h2 className="page-header">
                                <FormattedMessage
                                    id="faq.jobs.title"
                                    defaultMessage="Nous répondons à vos questions" />
                            </h2>
                            <p>
                                <FormattedMessage
                                    id="faq.jobs.subtitle"
                                    defaultMessage="Quels sont les profils et les compétences les plus demandées sur le marché du digital et de la tech ? Quelles sont les expertises de nos consultants ? Quelle est l'approche d'Urban Linker ? Découvrez toutes les réponses à vos questions."
                                />
                            </p>
                        </div>
                        <Faq
                            cardsBody={faqCardsBody}
                            cardsHeader={faqCardsHeader}
                            cardsLength="8"
                        />
                    </div>
                </div>
                <HomepageGuide />
                <SaveJobAlertModal
                    isOpen={this.state.saveJobAlertModal}
                    filters={pick(this.state, Object.keys(filtersInitialState))}
                    close={() => this.setState({saveJobAlertModal: false})}
                />
            </div>
        )
    }
}

export default withRouter(injectIntl(JobsPage));
